
export default {
    name: "popup_agenda",
    props: ["items", "currentWeek"],
    data(){
        return {
            isLoading: true,

            selectedLang: "en",

            selectedWeek: 1,
            weeks: [1,2,3,4,5,6],

            tabs: ["past", "this_week", "upcoming"],
            selectedTab: "this_week",

            langText: {
                en: {
                    view_ondemand: "View on-demand",
                    add_calendar: "Add to Calendar",
                    disclosure_title: "Disclosure Statement:" ,                
                    disclosure: "Do note that the information provided during the workshops is for general information only and does not take the place of professional or medical advice. The OCBC Group does not verify the information provided during workshops and makes no warranties in relation to such information. You should not rely on such information and instead seek advice relevant to your particular circumstances from a healthcare or other relevant professional and make your own independent assessment. By attending the workshop(s), you agree that the OCBC Group is not responsible or liable for any information provided during the workshop(s) and that you will not make any claim or take any action against the OCBC Group in relation to the foregoing."                 
                },
                cn: {
                    view_ondemand: "观看精彩重播",
                    add_calendar: "添加到日历",
                    disclosure_title: "须知：",            
                    disclosure: "请注意，工作坊期间提供的信息仅供参考，不能代替专业或医疗建议。华侨银行集团不负责对工作坊期间提供的信息进行核实，也不对此类信息作出任何保证。您不应依赖此类信息，而应根据自己的具体情况向医疗机构或其他相关专业人士寻求相关建议，并自行进行独立判断。参加工作坊即表示您同意华侨银行集团不对工作坊期间提供的任何信息负责，并且您不会就上述事宜向华侨银行集团提出任何索赔或发起任何诉讼。"                 
                },
            },

            wellnesses: [
                { title: "All", slug: "all" },
                { title: "Physical Wellness", slug: "physical" },
                { title: "Mental Wellness", slug: "mental" },
                { title: "Financial Wellness", slug: "financial" },
                { title: "Family Wellness", slug: "family" },
                { title: "Wellness at Workplace", slug: "workplace" },
            ],
            selectedWellness: "all",

            onDemandItems: [],
        }
    },
    computed: {
        selectedWeekItems(){
            console.log(this.items)
            const weekNumbers = Object.keys(this.items)
                .map(key => parseInt(key.replace("week", ""), 10))
               .filter(n => !isNaN(n));

            const totalWeeks = Math.max(...weekNumbers);

            let rawItems = [];
            // switch(this.selectedTab){
            //     case "past":
            //         return _.flatMap(_.range(1, this.currentWeek), week => this.items[`week${ week }`] || []);
            //     case "this_week":
            //         return this.items[`week${ this.currentWeek }`] || [];
            //     case "upcoming":
            //         return _.flatMap(_.range(this.currentWeek + 1, totalWeeks + 1), w => this.items[`week${w}`] || []);
            //     default:
            //         return [];
            // }
            switch(this.selectedTab) {
                case "past":
                    rawItems = _.flatMap(_.range(1, this.currentWeek), week => this.items[`week${ week }`] || []);
                    break;
                case "this_week":
                    rawItems = this.items[`week${ this.currentWeek }`] || [];
                    break;
                case "upcoming":
                    rawItems = _.flatMap(_.range(this.currentWeek + 1, totalWeeks + 1), w => this.items[`week${w}`] || []);
                    break;
                default:
                    rawItems = [];
            }
            if (this.selectedWellness === 'all') {
                return rawItems;
            }

            return rawItems.map(day => {
                const keepIndexes = day.wellness
                    .map((wArray, index) => wArray.includes(this.selectedWellness) ? index : null)
                    .filter(index => index !== null);

                return {
                    ...day,
                    wellness: keepIndexes.map(i => day.wellness[i]),
                    enitems: keepIndexes.map(i => day.enitems[i]),
                    cnitems: keepIndexes.map(i => day.cnitems[i])
                };
            }).filter(day => day.enitems.length > 0);
        },
        getDownloadPdfBtnLength(){
            const weekLang = `${ this.selectedTab }${ this.selectedLang }`;
            setTimeout(() => {
                const that = this;
                if($(".download-recipe-btn").length > 0){
                    $(".download-recipe-btn").off("click");
                    $(".download-recipe-btn").click(function (event){
                        that.onHandleTriggerAnalytics(`download@recipe@${ $($(this)[0]).data('title') }`); 
                    });
                }
            }, 1000);
        },
    },
    mounted(){
        this.$axios.$get(`/past_video/all`, this.tokenHeader).then((res) => {
            console.log("onDemandCallback", res);
            this.onDemandItems = res.items;
            this.isLoading = false;
        }).catch((err) => {
            console.error("onDemandError", err);
            return this.onHandleApiError(err);
        });
    },
    methods: {
        getWellness(wellness, count){
            return wellness[count];
        },
        isShowOnDemand(stamp){
            return !!_.find(this.onDemandItems, { stamp });
        },
        onClickDownloadIcs(item){
            this.onHandleTriggerAnalytics(`download@ics@${ item.stamp }`); 
        },
        onClickViewOnDemand(item){
            this.$emit("update:agendaOnDemandItem", item);
            this.onHandleTriggerAnalytics(`open@on_demand@agenda`); 
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@agenda`); 
        },
    },
    watch: {
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@agenda`); 
        }
    }
}
